import QrcodeVue from 'qrcode.vue'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import ComplaintsWidget from './ComplaintsWidget.vue'
import ruRU from './locales/ru_RU.json'

const widgetConfig = window.AUTH_ZVONOK_WIDGET_CONFIG

const locale = widgetConfig?.language ?? 'ru_RU'

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'ru_RU',
  messages: {
    ru_RU: ruRU,
    // если будут другие языки — добавить сюда
  },
})

export const initComplaintsWidget = () => {
  const container = document.querySelector('#complaints-widget')

  if (container) {
    const app = createApp(ComplaintsWidget, {
      country: widgetConfig?.country,
    })

    app.use(i18n)

    app.component('QrCode', QrcodeVue)

    app.mount(container)
  }
}
